module.exports = __webpack_public_path__ + "img/OPP stepping 1989.cbc72a89.jpg";